module.exports = __webpack_public_path__ + "static/img/01.d544813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01.png
// module id = LdeV
// module chunks = 0